import { render, staticRenderFns } from "./BasicInfoComponents.vue?vue&type=template&id=04328117&scoped=true"
import script from "./BasicInfoComponents.vue?vue&type=script&lang=js"
export * from "./BasicInfoComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04328117",
  null
  
)

export default component.exports